import {useEffect, useRef} from 'react'
import {useMutation} from '@apollo/client'
import {UPDATE_USER_PREFERENCES} from '../gql/mutations/userMutations'
import {useUserPreferencesStore} from '../store/userPreferencesStore'

export const useSyncPreferences = () => {
  const [updatePreferences] = useMutation(UPDATE_USER_PREFERENCES)
  const sidebarView = useUserPreferencesStore((s) => s.sidebarView)
  const sidebarFavorites = useUserPreferencesStore((s) => s.sidebarFavorites)
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null)
  const isFirstRender = useRef(true)

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false
      return
    }

    if (timerRef.current) clearTimeout(timerRef.current)

    timerRef.current = setTimeout(() => {
      updatePreferences({
        variables: {
          preferences: JSON.stringify({
            sidebar_view: sidebarView,
            sidebar_favorites: sidebarFavorites,
          }),
        },
      }).catch(console.error)
    }, 300)

    return () => {
      if (timerRef.current) clearTimeout(timerRef.current)
    }
  }, [sidebarView, sidebarFavorites, updatePreferences])
}
